/// <amd-module name="Wit/WorkItemBuildLinks/Components/BuildLinkState" />
import * as React from "react";
import { Icon } from "VSSUI/Icon";
import { ILinkDisplayData } from "Wit/WorkItemLinksRegistration/Contracts";
import { DefaultLinkTypeState } from "Wit/WorkItemLinksRegistration/Components";
import { Build, BuildResult, BuildStatus } from "Build/Client/Contracts/Build";

const classAndIconByStatus = new Map<BuildStatus, { className: string; iconName: string }>([
    [BuildStatus.InProgress, { className: "info-text", iconName: "Clock" }],
    [BuildStatus.NotStarted, { className: "info-text", iconName: "Clock" }],
    [BuildStatus.Postponed, { className: "warning-text", iconName: "Clock" }],
    [BuildStatus.Cancelling, { className: "error-text", iconName: "Clock" }]
]);

const classAndIconByResult = new Map<BuildResult, { className: string; iconName: string }>([
    [BuildResult.Succeeded, { className: "success-text", iconName: "CompletedSolid" }],
    [BuildResult.PartiallySucceeded, { className: "warning-text", iconName: "AlertSolid" }],
    [BuildResult.Failed, { className: "error-text", iconName: "StatusErrorFull" }],
    [BuildResult.Canceled, { className: "error-text", iconName: "StatusErrorFull" }],
]);

export function BuildLinkState({ link }: { link: ILinkDisplayData }) {
    const build = link.additionalData?.build as Build | undefined;
    if (!build) {
        return <DefaultLinkTypeState link={link} />;
    }

    const { className, iconName } = (build.status === BuildStatus.Completed
        ? classAndIconByResult.get(build.result)
        : classAndIconByStatus.get(build.status)) ?? { className: undefined, iconName: undefined };

    return (
        <div className={`inline-flex-row build-link-status ${className ?? ""}`}>
            <Icon className="icon-margin" iconName={iconName} />
            {link.state}
        </div>
    );
}
